/* tslint:disable */
/* eslint-disable */
/**
 * AddOnSelector.Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomerSelectionDto
 */
export interface CustomerSelectionDto {
    /**
     * 
     * @type {number}
     * @memberof CustomerSelectionDto
     */
    productId: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerSelectionDto
     */
    productTypeId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CustomerSelectionDto
     */
    roomId?: number;
}

/**
 * Check if a given object implements the CustomerSelectionDto interface.
 */
export function instanceOfCustomerSelectionDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "productId" in value;

    return isInstance;
}

export function CustomerSelectionDtoFromJSON(json: any): CustomerSelectionDto {
    return CustomerSelectionDtoFromJSONTyped(json, false);
}

export function CustomerSelectionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerSelectionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'productId': json['productId'],
        'productTypeId': !exists(json, 'productTypeId') ? undefined : json['productTypeId'],
        'roomId': !exists(json, 'roomId') ? undefined : json['roomId'],
    };
}

export function CustomerSelectionDtoToJSON(value?: CustomerSelectionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'productId': value.productId,
        'productTypeId': value.productTypeId,
        'roomId': value.roomId,
    };
}

